export default __webpack_public_path__ + "static/media/meeting_detail_triangle.276d9005.svg";